export default __webpack_public_path__ + "static/media/icon_search.4ff7c1b8.svg";